import i18n from '@vision/ui/i18n';

export function getBodyText(translations: Record<string, string>, selectedLanguage = i18n.language): string {
  return translations[selectedLanguage.toUpperCase()] ?? translations.EN ?? translations[Object.keys(translations)[0]];
}
